import { render, staticRenderFns } from "./SlotHandler.vue?vue&type=template&id=51cde331"
import script from "./SlotHandler.vue?vue&type=script&lang=js"
export * from "./SlotHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports